import { render, staticRenderFns } from "./TraingaiqianRight.vue?vue&type=template&id=2ba8ede6&scoped=true"
import script from "./TraingaiqianRight.vue?vue&type=script&lang=js"
export * from "./TraingaiqianRight.vue?vue&type=script&lang=js"
import style0 from "./TraingaiqianRight.vue?vue&type=style&index=0&id=2ba8ede6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8ede6",
  null
  
)

export default component.exports